import React from 'react'
import { SwipeableGrid, useContainerWidth } from '@fs/zion-ui'

export default function CardCarousel({ children, columnCount }) {
  const atWidth = useContainerWidth()
  return (
    <SwipeableGrid gutters="xs" columnCount={columnCount || atWidth({ default: 1, sm: 2, md: 3, xl: 4, xxl: 5 })}>
      {children}
    </SwipeableGrid>
  )
}
